<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="900"
    scrollable
  >
    <v-card
      tile
      min-height="350"
      :loading="!invitation"
    >
      <v-card-title
        class="primary font-weight-medium grey--text pt-1 pb-2 px-3"
      >
        Datos de la invitación | Checkin
      </v-card-title>
      <v-card-subtitle class="primary pb-2 px-3">
        Complete o consulte los datos de la invitación
      </v-card-subtitle>
      <v-card-text class="px-0">
        <v-container v-if="invitation" fluid>
          <v-row>
            <v-col cols="12" sm="8">
              <v-row>
                <v-col cols="12">
                  <input-component
                    v-model="invitation.type_invitation.name"
                    :v="{}"
                    :errors="[]"
                    :label="'Tipo de invitación'"
                    :disabled="true"
                  />
                </v-col>
                <v-col v-if="invitation.property" cols="12">
                  <input-component
                    v-model="invitation.property"
                    :v="{}"
                    :errors="[]"
                    :label="'Propiedad a visitar'"
                    :disabled="true"
                  />
                </v-col>
                <v-col v-if="invitation.venue.name" cols="12">
                  <input-component
                    v-model="invitation.venue.name"
                    :v="{}"
                    :errors="[]"
                    :label="'Propiedad a visitar'"
                    :disabled="true"
                  />
                </v-col>
                <v-col cols="8">
                  <input-component
                    v-model="checkin.guest.name"
                    :v="{}"
                    :errors="[]"
                    :label="'Nombre del invitado'"
                    :disabled="true"
                  />
                </v-col>
                <v-col cols="4">
                  <select-component
                    v-model="checkin.guest.type_identification"
                    :v="{}"
                    :errors="[]"
                    :label="'Tipo de identificacion'"
                    :items="identificationTypes"
                    :translate="true"
                  />
                </v-col>
                <v-col cols="6">
                  <masked-input-component
                    v-model="checkin.guest.identification"
                    :v="$v.checkin.guest.identification"
                    :errors="errorsIdentification"
                    :label="'Número de documento'"
                    :mask="identificationMask(checkin.guest.type_identification)"
                  />
                </v-col>
                <v-col cols="4">
                  <select-component
                    v-model="checkin.total_companions"
                    :v="$v.checkin.persons"
                    :errors="errorsAnyPerson"
                    :label="'Acompañantes'"
                    :items="items"
                  />
                </v-col>
                <v-col cols="2" align="end" class="pl-0">
                  <v-btn
                    outlined
                    color="light-blue lighten-3"
                    @click="showCompanions = !showCompanions"
                    height="40"
                  >
                    ...
                  </v-btn>
                </v-col>
                <v-expand-transition>
                <v-col cols="12" v-if="showCompanions">
                  <v-card class="elevation-3">
                    <v-card-title class="font-weight-medium grey--text pt-1 pb-2 px-3">
                      Acompañantes
                    </v-card-title>
                    <v-card-text>
                      <v-row v-for="(item, i) in checkin.persons" :key="i">
                        <v-col cols="5" class="px-1">
                          <input-component
                            v-model="checkin.persons[i].name"
                            :v="$v.checkin.persons.$each[i].name"
                            :errors="errorsPersons(i, 'name')"
                            :label="'Nombre completo'"
                          />
                        </v-col>
                        <v-col cols="3" class="px-1">
                          <select-component
                            v-model="checkin.persons[i].type_identification"
                            :v="$v.checkin.persons.$each[i].name"
                            :errors="errorsPersons(i, 'type_identification')"
                            :label="'Tipo de identificación'"
                            :items="identificationTypes"
                            :translate="true"
                          />
                        </v-col>
                        <v-col cols="4" class="px-1">
                          <masked-input-component
                            v-model="checkin.persons[i].identification"
                            :v="$v.checkin.persons.$each[i].identification"
                            :errors="errorsPersons(i, 'identification')"
                            :label="'No. de identificacion'"
                            :mask="identificationMask(checkin.persons[i].type_identification)"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                </v-expand-transition>
                <v-col cols="6">
                  <select-component
                    v-model="checkin.transport.medio"
                    :v="$v.checkin.transport.medio"
                    :errors="errorsTransport('medio')"
                    :label="'Tipo de transporte'"
                    :items="transportTypes"
                    :translate="true"
                  />
                </v-col>
                <v-col cols="6">
                  <select-component
                    v-model="checkin.transport.color"
                    :v="$v.checkin.transport.color"
                    :errors="errorsTransport('color')"
                    :label="'Color transporte'"
                    :items="transportColors"
                    :translate="true"
                  />
                </v-col>
                <v-col cols="6">
                  <input-component
                    v-model="checkin.transport.plate"
                    :v="$v.checkin.transport.plate"
                    :errors="errorsTransport('plate')"
                    :label="'Número de placa'"
                  />
                </v-col>
                <v-col cols="3">
                  <input-component
                    :value="dateForDisplay(invitation.date_entry)"
                    :v="{}"
                    :errors="[]"
                    :label="'F. llegada'"
                    :disabled="true"
                  />
                </v-col>
                <v-col cols="3">
                  <input-component
                    :value="dateForDisplay(invitation.date_out)"
                    :v="{}"
                    :errors="[]"
                    :label="'F. salida'"
                    :disabled="true"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="4">
              <v-row>
                <v-col cols="12">
                  <textarea-component
                    v-model="invitation.note"
                    :v="{}"
                    :errors="[]"
                    :label="'Nota del propietario'"
                    :disabled="true"
                  />
                </v-col>
                <v-col cols="12">
                  <textarea-component
                    v-model="checkin.note"
                    :v="{}"
                    :errors="[]"
                    :label="'Observaciones al check-in'"
                  />
                </v-col>
                <v-col cols="12">
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions v-if="invitation">
        <v-spacer></v-spacer>
        <v-btn
          outlined
          color="grey"
          @click="closeDialog"
        >
          Cancelar
        </v-btn>
        <v-btn
          depressed
          color="success"
          @click="makeCheckin"
          :loading="sending"
        >
          Check-in
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import types from '@/types';
import InputComponent from '@/components/forms/InputComponent';
import MaskedInputComponent from '@/components/forms/MaskedInputComponent';
import SelectComponent from '@/components/forms/SelectComponent';
import TextareaComponent from '@/components/forms/TextareaComponent';
import PropertyService from '@/services/PropertyService';
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';

export default {
  props: [
    'value',
    'invitationId',
  ],

  components: {
    InputComponent,
    MaskedInputComponent,
    SelectComponent,
    TextareaComponent,
  },

  data() {
    return {
      sending: false,
      checkin: this.newCheckin(),
      items: [
        0, 1, 2, 3, 4,
      ],
      showCompanions: false,
      propertyService: PropertyService,
    };
  },

  validations: {
    checkin: {
      guest: {
        identification: {
          required,
        },
      },
      persons: {
        $each: {
          name: {
            required,
          },
          type_identification: {
            required,
          },
          identification: {
            required,
          },
        },
      },
      transport: {
        medio: {
          required,
        },
        color: {
          required,
        },
        plate: {
          required,
        },
      },
    },
  },

  watch: {
    dialog(value) {
      if (value) {
        this[types.GET_INVITATION_CHECKIN](this.invitationId);
      }
    },
    invitation() {
      if (!this.invitation) {
        return;
      }
      this.checkin.guest.name = this.guest.name;
      this.checkin.guest.type_identification = this.guest.type_identification;
      this.checkin.guest.identification = this.guest.identification;
      this.checkin.total_companions = this.invitation.total_companions;
      if (this.isTypeVisitorsCenter) {
        this.checkin.transport = this.invitation.checkin.transport;
        this.checkin.persons = this.invitation.checkin.persons;
      }
      if (this.isTypeSupplier) {
        this.checkin.transport = this.invitation.supplier.transportation;
      }
    },
    'checkin.total_companions': {
      handler(value) {
        if (value === 0) {
          this.checkin.persons = [];
          return;
        }
        const total = value - this.checkin.persons.length;
        if (total > 0) {
          for (let i = 0; i < total; i += 1) {
            const person = { name: '', type_identification: '', identification: '' };
            this.checkin.persons.push(person);
          }
        } else {
          for (let i = 0; i < total * -1; i += 1) {
            this.checkin.persons.pop();
          }
        }
      },
      deep: true,
    },
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    ...mapState(
      `${types.INVITATION}`, [
        'invitation',
        'invitationTypes',
        'identificationTypes',
        'transportTypes',
        'transportColors',
        'typeVisitorsCenter',
        'typeSupplier',
      ],
    ),
    isTypeVisitorsCenter() {
      return this.invitation.type_invitation === 'Visitor Center'
        || this.invitation.type_invitation === this.typeVisitorsCenter;
    },
    isTypeSupplier() {
      return this.invitation.type_invitation === 'Supplier'
        || this.invitation.type_invitation === this.typeSupplier;
    },
    guest() {
      if (this.invitation && this.invitation.invitated) {
        return this.invitation.invitated;
      }
      return {};
    },
    errorsIdentification() {
      const errors = [];
      if (!this.$v.checkin.guest.identification.$dirty) {
        return errors;
      }
      if (!this.$v.checkin.guest.identification.required) {
        errors.push('Introduzca la identificación.');
      }
      return errors;
    },
    errorsAnyPerson() {
      const errors = [];
      if (!this.$v.checkin.persons.$anyDirty) {
        return errors;
      }
      if (this.$v.checkin.persons.$anyError) {
        errors.push('Complete la información de los acompañantes.');
      }
      return errors;
    },
  },

  methods: {
    ...mapMutations(
      `${types.APP}`, [
        types.SHOW_BUSY,
        types.HIDE_BUSY,
        types.SHOW_SUCCESS,
        types.SHOW_ERROR,
      ],
    ),
    ...mapMutations(
      `${types.INVITATION}`, [
        types.SET_INVITATION,
      ],
    ),
    ...mapActions({
      [types.GET_INVITATION_CHECKIN]: `${types.INVITATION}/${types.GET_INVITATION_CHECKIN}`,
      [types.CHECK_IN]: `${types.INVITATION}/${types.CHECK_IN}`,
    }),
    closeDialog() {
      this.dialog = false;
      this.showCompanions = false;
      setTimeout(() => {
        this[types.SET_INVITATION]();
        this.checkin = this.newCheckin();
        this.$v.$reset();
      }, 500);
    },
    newCheckin() {
      return {
        guest: {
          name: '', type_identification: '', identification: '',
        },
        total_companions: '',
        persons: [
        ],
        transport: {
          medio: '', color: '', plate: '',
        },
      };
    },

    makeCheckin() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.sending = true;
      this[types.CHECK_IN]({ invitationId: this.invitationId, checkinForm: this.checkin })
        .then(() => {
          this[types.SHOW_SUCCESS]('Check-in realizado.');
          this.closeDialog();
        })
        .catch(() => {
          this[types.SHOW_ERROR]('Hubo un error realizando el check-in.');
        })
        .finally(() => {
          this.sending = false;
        });
    },
    dateForDisplay(date) {
      return date ? moment(date).format('D/M/YYYY') : '';
    },
    errorsPersons(idx, field) {
      const errors = [];
      if (!this.$v.checkin.persons.$each[idx][field].$dirty) {
        return errors;
      }
      if (!this.$v.checkin.persons.$each[idx][field].required) {
        errors.push('This field is required.');
      }
      return errors;
    },
    errorsTransport(field) {
      const errors = [];
      if (!this.$v.checkin.transport[field].$dirty) {
        return errors;
      }
      if (!this.$v.checkin.transport[field].required) {
        errors.push('This field is required.');
      }
      return errors;
    },
    identificationMask(identificationTypeId) {
      const identificationType = this.identificationTypes.find(
        (item) => item.id === identificationTypeId,
      );
      if (identificationType && identificationType.name.toLowerCase() === 'cedula') {
        return '###-#######-#';
      }
      return 'XXXXXXXXXXXXX';
    },
    getVenueEventName(invitation) {
      let name;
      if (invitation.content_type === 'venue') {
        name = invitation.venue.name;
      }
      if (invitation.content_type === 'event') {
        name = `${invitation.event.name} @ ${invitation.venue.name}`;
      }
      return name;
    },
  },

  mounted() {
    this.checkin = this.newCheckin();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CheckinComponent.vue